export const getTotalPage = (totalData, limit) => {
  const divid = Math.floor(totalData / limit)
  const sisa = totalData % limit;
  const convertSisa = sisa === 0 ? 0 : 1

  return divid + convertSisa
}